import React, { useEffect, useRef, useState } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../../../@shared/icon';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import { documentService } from '../../../../utils/window.utils';
import { iconSize } from '../../../../constants/icon.constants';
import { HEADER_HEIGHT } from '../../../../constants/header.constants';
import './styles.scss';

const HighLevelAlertMessage = () => {
  const ALERT_MESSAGE_COOKIE_MAX_AGE = 60 * 60 * 24 * 1; //1 day
  const ALERT_MESSAGE_COOKIE_NAME = 'casece';
  const ALERT_MESSAGE_COOKIE_VALUE = 'alert_message';

  const context = useSitecoreContext();
  const hostAppRoot = context?.sitecoreContext?.hostAppRoot || '';
  const cookiePath = hostAppRoot.endsWith('/') ? hostAppRoot.slice(0, -1) : hostAppRoot;
  const [canShowAlert, setCanShowAlert] = useState(() => {
    if (!documentService().body) return null;
    const isCookiePresent = documentService().cookie?.split(`${ALERT_MESSAGE_COOKIE_NAME}=${ALERT_MESSAGE_COOKIE_VALUE}`).length > 1;
    return !isCookiePresent;
  });
  const refWrapper = useRef<HTMLDivElement>(null);
  const msgheight = refWrapper.current?.clientHeight || 0;
  const totalHeight = msgheight + HEADER_HEIGHT;
  const messageTitle = context?.sitecoreContext?.severitySettings?.title;
  const messageDescription = context?.sitecoreContext?.severitySettings?.description;

  const onCloseIconClick = () => {
    setCanShowAlert(false);
    documentService().body.style.removeProperty('--navigation-custom-height');
    documentService().cookie = `${ALERT_MESSAGE_COOKIE_NAME}=${ALERT_MESSAGE_COOKIE_VALUE}; max-age=${ALERT_MESSAGE_COOKIE_MAX_AGE}; path=${cookiePath};`;
  };

  useEffect(() => {
    documentService().body.style.setProperty('--navigation-custom-height', `${totalHeight}px`);
    return (): void => {
      documentService().body.style.removeProperty('--navigation-custom-height');
    };
  }, [totalHeight]);

  if (!canShowAlert) return null;

  return (
    <div className="alert-message" ref={refWrapper}>
      <div className="alert-message__icon-wrapper">
        <Icon iconName="info-alert-notif-triangle-alert" size={iconSize.md} color="primary" />
      </div>
      <div className={!messageDescription ? 'alert-message__without-description' : 'alert-message__alert-message-content'}>
        <RichText tag="div" field={{ value: messageTitle }} className="alert-message__title" />
        {messageDescription && <RichText tag="div" field={{ value: messageDescription }} className="alert-message__description" />}
      </div>
      <Icon
        iconName="action-close"
        size={iconSize['dsk']}
        color="warning"
        onClick={onCloseIconClick}
        extraClassName="alert-message__close"
      />
    </div>
  );
};
export default HighLevelAlertMessage;
